const state = {
  languages: [
    {label: 'English', value: 'en'},
    {label: 'Polish', value: 'pl'}
  ]
};

const actions = {
  setLanguages({commit}, data) {
    commit('setLanguages', data);
  }
};

const mutations = {
  setLanguages(state, data) {
    state.languages = data;
  }
};

const getters = {
  languages(state) {
    return state.languages;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
